import React, { useEffect, useState } from 'react';
import { logger } from 'src/commons/utils/logger';
import { requestWithRetry } from 'src/commons/utils/asyncRequest';
import {
  PopoverMultipleLines,
  PopoverWithContent,
  TextLinkPopover,
  TextLinkPopoverRemote,
} from '../types';
import {
  DynamicPopover,
  isValidPopoverResponse,
  MultipleLines,
} from '../utils';
import { TextButtonPopoverAttribute } from '@amzn/storm-ui-page-header';

export const ajaxGetPopoverResponse = async (
  url: string,
): Promise<PopoverMultipleLines | PopoverWithContent | string | null> => {
  try {
    const response = await requestWithRetry({
      url,
    });
    if (!response.data) return null;
    if (isValidPopoverResponse(response.data)) return response.data;
    return response.data;
  } catch (error: any) {
    logger.info(
      `asyncRequests - textLinkPopoverRemote get request for endpoint ${url}. error: ${error}`,
    );
    return null;
  }
};

export const AttributesTextLinkPopover: React.VFC<
  TextLinkPopoverRemote | TextLinkPopover
> = (props) => {
  const { id, label, content, ariaLabel, tooltipPosition, withCloseButton } =
    props;
  const { popoverContent } = props as TextLinkPopover;
  const { popoverAPI, apiCallFailureMessage } = props as TextLinkPopoverRemote;
  const [tooltipContent, setTooltipContent] = useState<any>(null);

  useEffect(() => {
    if (popoverAPI) {
      const fetchPopoverContent = async () => {
        const response = await ajaxGetPopoverResponse(popoverAPI);
        setTooltipContent(response);
      };
      fetchPopoverContent();
    }
  }, []);

  if (!popoverContent && (!popoverAPI || !apiCallFailureMessage)) return null;

  const TooltipContent = () =>
    popoverContent ? (
      <MultipleLines lines={popoverContent} />
    ) : (
      <DynamicPopover popover={tooltipContent ?? apiCallFailureMessage} />
    );

  return (
    <TextButtonPopoverAttribute
      id={id}
      prefixLabel={label}
      content={content}
      popoverContent={<TooltipContent />}
      popoverPosition={tooltipPosition}
      withCloseButton={withCloseButton}
      aria-label={ariaLabel}
      data-ccx-e2e-id={`aac-attribute-${id}`}
    />
  );
};
